module.exports = __webpack_public_path__ + "static/media/image-bg-bussines-page.986a643f.jpg";